import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  faqs = [
    {
      question: 'Wat is Kansino Nederland?',
      answer: 'Kansino Nederland is een affiliate website die de beste online casino platforms in Nederland beoordeelt en vergelijkt.'
    },
    {
      question: 'Zijn de casino platforms veilig?',
      answer: 'Wij beoordelen alleen platforms met geldige licenties en goede reputaties. We testen regelmatig de veiligheid en betrouwbaarheid.'
    },
    {
      question: 'Hoe verdient Kansino Nederland geld?',
      answer: 'Wij ontvangen een commissie wanneer u via onze links een account opent bij een casino platform. Dit heeft geen invloed op onze beoordelingen.'
    },
    {
      question: 'Kan ik gratis spelen?',
      answer: 'Veel platforms bieden gratis spins of demo accounts aan. Controleer de individuele platformpagina\'s voor meer informatie.'
    },
    {
      question: 'Wat is de minimumleeftijd om te gokken?',
      answer: 'De minimumleeftijd om te gokken in Nederland is 18 jaar. Deze website is alleen bedoeld voor personen van 18 jaar en ouder.'
    }
  ];

  expandedIndex: number | null = null;

  toggle(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
}

